<template>
<div>
  <v-main class="pt-2">
    <v-card outlined class="mb-2 rounded-xl">
      <div class="example">
        <apexcharts height="350" type="heatmap" id="mChart" :options="chartOptions" :series="series"></apexcharts>
      </div>
      <v-card-text class="px-2 grey lighten-4">
        <div class="headline">Senhas liberadas por hora</div>
      </v-card-text>
    </v-card>
  </v-main>
</div>
</template>

<script>
import administradorUnidadeService from './../../../services/administradorUnidade.service'
// import { EventBus } from './../../../main'
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'funcionariosOnline',
  components: {
    apexcharts: VueApexCharts
  },
  props: {
    exames: {
      type: Array
    }
  },
  data () {
    return {
      senhasGeradas: [],
      quantatendimentosStatus: [],
      textTempoAtualizado: '',
      intervalRegistroSocket: '',
      hora: null,
      load: 0,
      graficoExames: [],
      series: [],
      chartOptions: {
        chart: {
          id: 'mChart',
          height: 350,
          type: 'heatmap',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: true,
            colorScale: {
              ranges: [{
                from: -30,
                to: 5,
                name: 'biaxo',
                color: '#90A4AE'
              },
              {
                from: 6,
                to: 20,
                name: 'médio',
                color: '#9CCC65'
              },
              {
                from: 21,
                to: 45,
                name: 'alto',
                color: '#66BB6A'
              },
              {
                from: 46,
                to: 55,
                name: 'extremo',
                color: '#00BCD4'
              }
              ]
            }
          }
        },
        xaxis: {
          categories: []
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 1
        }
      },

      arrayChartSenhasGeradas: [],
      chartSenhasGeradas: null,
      chartAtendimentoStatus: null,
      dadosGrafico: []
    }
  },

  mounted () {
    console.log('em servicos unidade...')
    this.user = this.$store.getters.usuario
    // EventBus.$on('carregarTempoEspera', this.carregarTempoEspera)
    // EventBus.$on('carregarDados', this.carregarDadosTabelas)
    // this.carregarDadosTabelas()
    this.getExameHora()
  },

  methods: {
    generateData (count, yrange) {
      var i = 0
      var series = []
      while (i < count) {
        var x = 'w' + (i + 1).toString()
        var y =
        Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min

        series.push({
          x: x,
          y: y
        })
        i++
      }
      return series
    },

    getHoras () {
      var horas = []
      for (let i = 6; i < 18; i++) {
        horas.push(i)
      }
      return horas
    },
    getHora (hora) {
      let categorias = []
      for (let i = 0; i < this.exames.length; i++) {
        const e = this.exames[i]
        if (hora == e.horas) {
          console.log(e)
          // this.seriesExames[0].data.push(e.quantExames)
          this.chartOptionsExames.xaxis.categories.push(e.nomeExame)
          categorias.push(e.nome)
        }
      }
      // ApexCharts.exec('myChartExame', 'updateOptions', {
      //   xaxis: {
      //     categories: this.chartOptionsExames.xaxis.categories
      //   }
      // }, false, true)

      ApexCharts.exec('myChartExame', 'updateSeries', [{
        data: this.seriesExames[0].data
      }], true)
      ApexCharts.exec('myChartExame').render()
    },
    formatarTempo (tempo) {
      var a = tempo.split(':')
    },
    carregarTempoEspera (tempoEspera) {
      this.tempoEspera = tempoEspera
    },

    carregarDadosTabelas (date1, date2) {
      this.retornarExameHora(date1, date2)
    },
    getExameHora () {
      let series = []
      let horas = []
      for (let i = 0; i < this.exames.length; i++) {
        const e = this.exames[i]
        if (!horas.includes(e.horas)) {
          horas.splice(e.horas, 0, e.horas)
        }
        if (series.length > 0) {
          let index = null
          for (let j = 0; j < series.length; j++) {
            const s = series[j]
            if (s.idExame === e.idExame) {
              index = j
              break
            }
          }

          if (index != null) {
            series[index].data.splice(e.horas, 0, e.quantExames)
          } else {
            series.push({
              name: e.nomeExame,
              data: [e.quantExames],
              idExame: e.idExame
            })
          }
        } else {
          series.push({
            name: e.nomeExame,
            data: [e.quantExames],
            idExame: e.idExame
          })
        }
        this.series = series
      }
      // ApexCharts.exec('myChartExame', 'updateSeries', series, true)
      horas.sort(function (a, b) { return a - b })
      let mHoras = []
      horas.forEach(h => {
        mHoras.push(`${h}h`)
      })
      ApexCharts.exec('mChart', 'updateOptions', {
        xaxis: {
          categories: mHoras
        }
      }, false, true)
    },
    retornarExameHora (date1, date2) {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .retornarExameHora(date1, date2)
        .then((rsp) => {
          console.log('rsp retornarExameHora', rsp.data)
          if (rsp.data.length > 0) {
            this.exames = rsp.data
            let series = []
            let horas = []
            for (let i = 0; i < this.exames.length; i++) {
              const e = this.exames[i]
              if (!horas.includes(e.horas)) {
                horas.splice(e.horas, 0, e.horas)
              }
              if (series.length > 0) {
                let index = null
                for (let j = 0; j < series.length; j++) {
                  const s = series[j]
                  if (s.idExame === e.idExame) {
                    index = j
                    break
                  }
                }
                if (index != null) {
                  series[index].data.splice(e.horas, 0, e.quantExames)
                } else {
                  series.push({
                    name: e.nomeExame,
                    data: [e.quantExames],
                    idExame: e.idExame
                  })
                }
              } else {
                series.push({
                  name: e.nomeExame,
                  data: [e.quantExames],
                  idExame: e.idExame
                })
              }
            }
            // this.chartOptions.xaxis.categories = horas
            ApexCharts.exec('myChartExame', 'updateSeries', series, true)
            horas.sort(function (a, b) {
              return a - b
            })
            let mHoras = []
            horas.forEach(h => {
              mHoras.push(`${h}h`)
            })
            ApexCharts.exec('mChart', 'updateOptions', {
              xaxis: {
                categories: mHoras
              }
            }, false, true)
          }
        })
        .finally(() => {
          this.load = this.load - 1
        })
        .catch((err) => {
          // handle your error
          this.loadingTabela1 = false
          console.log(err)
        })
    },

    converterDate (data) {
      if (data == '---') {
        return '---'
      } else {
        var d = new Date(data)
        var dia = d.getDate().toString()
        var diaF = dia.length == 1 ? '0' + dia : dia
        var mes = (d.getMonth() + 1).toString() // +1 pois no getMonth Janeiro começa com zero.
        var mesF = mes.length == 1 ? '0' + mes : mes
        var anoF = d.getFullYear()

        return diaF + '/' + mesF + '/' + anoF
      }
    }
  },
  watch: {
    hora: function (val) {
      this.getHora(val)
    },
    exames: function (val) {
      this.getExameHora()
    }
  },
  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
